export default {
  title: "Factuur aan",

  input :{
    title: "Wie wordt er gefactureerd",

    module: "Type",
    target: "Doel",
    address: "Adres",
    email: "E-mailadres"
  },

  view: {
    entityName: {
      label: "Naam",
      noValue: "Geen doel geselecteerd",
    },
    entityAddress: {
      label: "Adres",
      noValue: "Geen adres geselecteerd",
    },
    entityEmail: {
      label: "E-mailadres",
      noValue: "Geen e-mailadres geselecteerd",
    }
  },
}
